import {
  CeiLoadingConfig,
  resolverConfiguracaoCarregamento,
} from '@cei-ufg/ngx-arquitetura-cei-frontend';

/** Overlay claro e spinner compacto nas tabelas administrativas. */
export const ADMIN_CARREGAMENTO_TABELA: Partial<CeiLoadingConfig> = {
  overlay: 'parent',
  overlayBackground: 'rgba(255, 255, 255, 0.72)',
  width: '5.5rem',
  height: '5.5rem',
  message: 'Carregando ...',
  color: '#584098',
  exibirMensagem: false,
};

/** Overlay claro em operações de formulário (viewport). */
export const ADMIN_CARREGAMENTO_FORMULARIO: Partial<CeiLoadingConfig> = {
  overlay: 'viewport',
  overlayBackground: 'rgba(255, 255, 255, 0.78)',
  width: '3rem',
  height: '3rem',
  color: '#584098',
  messageColor: '#535355',
  exibirMensagem: true,
};

/** Resolve configuração de loading para telas de associação do admin. */
export function adminCarregamentoFormulario(mensagem: string) {
  return resolverConfiguracaoCarregamento({ message: mensagem }, ADMIN_CARREGAMENTO_FORMULARIO);
}
